import { LogEvent } from '../types';
import { LogTransport } from './LogTransport';

/**
 * Writes each event to `console` as a single-line JSON string, routed to the
 * `console` method that matches the event's severity (`error`/`warn`/`log`).
 *
 * Used as a default sink in development and as a safety-net fallback when
 * remote transports (added in later PRs) are unavailable.
 */
export class ConsoleTransport implements LogTransport {
    public send(event: LogEvent): void {
        try {
            const line = JSON.stringify(event);
            /* eslint-disable no-console */
            switch (event.level) {
                case 'ERROR':
                    console.error(line);
                    break;
                case 'WARN':
                    console.warn(line);
                    break;
                default:
                    console.log(line);
            }
            /* eslint-enable no-console */
        } catch {
            // Transport contract: never throw. Drop the event silently.
        }
    }
}
